import React from 'react';
import PropTypes from 'prop-types';

const GameStructuredData = ({
  path,
  title,
  description,
  image,
  createdAt,
  updatedAt,
}) => {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Game',
          name: title,
          headline: title,
          description: description,
          mainEntityOfPage: `//m.giveuptobacco.com${path}`,
          image: image,
          dateCreated: createdAt,
          datePublished: createdAt,
          dateModified: updatedAt || createdAt,
          thumbnailUrl: image,
          author: {
            '@type': 'Thing',
            name: 'education.com',
          },
          publisher: {
            '@type': 'Organization',
            name: 'education.com',
            logo: {
              '@type': 'ImageObject',
              url: '//m.giveuptobacco.com/i/logo/EDU-Logo-new-286x60.png',
              width: 286,
              height: 60,
            },
          },
        }),
      }}
    />
  );
};

GameStructuredData.propTypes = {
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string,
};

export default GameStructuredData;
